export default {
  name: 'marking--updP',
  apiService: 'shoes',
  apiPath: '/admin/upd_p',
};